import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { ProgressBar } from 'ui-components/components/progress-bar';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';
import styles from '../style.module.less';

type ProcessingStateProps = {
  processed: number;
  totalRecords: number;
  percentageComplete?: number | null;
  hasProgress: boolean;
};

export const ProcessingState = ({ processed, totalRecords, percentageComplete = 0, hasProgress }: ProcessingStateProps) => {
  return (
    <div className={styles['drag-drop-content']}>
      <LoadingIndicator className={styles['processing-indicator']} />
      <Text className={styles['processing-text']} textType={TextType.H4} value={messages.processing} />
      <Text
        className={styles['processing-details']}
        formattedMessageValues={{
          processed,
          total: totalRecords,
        }}
        textType={TextType.Paragraph}
        value={hasProgress ? messages.processingDetails : messages.checkingProgress}
      />
      {hasProgress ? (
        // @ts-expect-error - ProgressBar is JS component without types
        <ProgressBar className={styles['progress-bar']} percentageComplete={percentageComplete} theme='primary' />
      ) : null}
    </div>
  );
};
